import * as React from 'react';
import {
  Grid,
  GridCellProps,
  GridColumn,
  GridDataStateChangeEvent,
  GridDetailRowProps,
  GridCustomFilterCellProps,
  GridRowDoubleClickEvent,
  GridToolbar,
  isColumnMenuSortActive,
  isColumnMenuFilterActive,
} from '@progress/kendo-react-grid';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { DataResult, process, State } from '@progress/kendo-data-query';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import {
  IntlProvider,
  LocalizationProvider,
  loadMessages,
  load,
} from '@progress/kendo-react-intl';
import { locales, LocaleInterface } from '../../AlertsGrid/GridLocale';
import {
  Checkbox,
  createStyles,
  FormControlLabel,
  makeStyles,
  Theme,
} from '@material-ui/core';
import {
  Button,
  DropDownButton,
  DropDownButtonItemClickEvent,
} from '@progress/kendo-react-buttons';
import {
  setGroupIds,
  DetailExpandDescriptor,
} from '@progress/kendo-react-data-tools';
import weekData from 'cldr-core/supplemental/weekData.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import caGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import numbers from 'cldr-numbers-full/main/fr/numbers.json';
import dateFields from 'cldr-dates-full/main/fr/dateFields.json';
import timeZones from 'cldr-dates-full/main/fr/timeZoneNames.json';
import esMessages from '../../../utils/gridMessageKey.json';
loadMessages(esMessages, 'fr-CA');
load(
  likelySubtags,
  currencyData,
  weekData,
  caGregorian,
  numbers,
  dateFields,
  timeZones
);
import StringResourceManager, { GetString } from '../../StringResourceManager';
import { CSVLink } from 'react-csv';
import {
  getCurrentDateYYYYMMDD,
  getDateTimeLocaleString,
  getLocalDateTime,
} from '../../../utils/utils';
import { ApiEnums } from '../../../Interfaces/ApiEnums';
import {
  fetchPredMaintenanceRecords,
  resetFetchError,
  updatePredMaintenanceRecord,
} from '../../../store/Maintenance/MaintenanceActions';
import {
  GridLayout,
  GridLayoutItem,
  Splitter,
  SplitterOnChangeEvent,
} from '@progress/kendo-react-layout';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { predMaintenanceStatusTextMap } from '../../../utils/textMappings';
import {
  useChipStylesBlue,
  useChipStylesDarkOrange,
  useChipStylesGreen,
  useChipStylesGrey,
  useChipStylesOrange,
} from '../../ChipStyles';
import { Chip } from '@progress/kendo-react-buttons';
import {
  checkCircleIcon,
  questionCircleIcon,
  clockArrowRotateIcon,
  chevronDownIcon,
  calendarIcon,
  wrenchIcon,
} from '@progress/kendo-svg-icons';
import {
  PredictiveMaintenanceRecord,
  PredictiveMaintenanceRecordCSV,
} from '../../../Interfaces/Maintenance/PredictiveMaintenanceRecord';
import { PredictiveMaintenanceStatusFilterCell } from './PredictiveMaintenanceStatusFilterCell';
import PredMaintenanceFilter from './PredMaintenanceFilter';
import {
  ColumnMenu,
  CustomCell,
  HeaderCustomCell,
} from '../../ColumnMenus/ColumnMenu';
import { savePredMaintenanceGridState } from '../../../store/UserSettings/UserSettingsActions';
import { CustomDateFilterCell } from '../../CustomDateFilterCell';
import { PreventiveMaintenanceRecord } from '../../../Interfaces/Maintenance/PreventiveMaintenanceRecord';
import {
  Notification,
  NotificationGroup,
} from '@progress/kendo-react-notification';
import { FetchError } from '../../../Interfaces/FetchError';
import { Fade } from '@progress/kendo-react-animation';

// Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chipStyle: {
      width: 155,
      minHeight: 45,
      margin: 'auto',
      fontWeight: 'bold',
    },
    chipContent: {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'right',
      justifyContent: 'space-between',
    },
    bottomRight: {
      right: 0,
      bottom: 0,
      alignItems: 'flex-start',
      flexWrap: 'wrap-reverse',
    },
    error: {
      fontSize: '1.5rem',
    },
    toolbar: {
      height: 65,
      alignItems: 'flex-end',
      padding: theme.spacing(1),
      gap: 10,
    },
    toolbarButton: {
      height: 40,
      marginRight: 9,
    },
    toolbarButtonContainer: {
      display: 'grid',
    },
    toolbarButtonGrid: {
      display: 'flex',
    },
    imageCell: {
      height: '48px',
      width: '75px',
    },
    column: {
      textALign: 'center',
    },
    addItemButton: {
      display: 'flex',
      marginLeft: '10px',
    },
    icon: {
      marginTop: '-5px',
      marginLeft: '5px',
    },
    maintenanceDialog: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      flexWrap: 'wrap',
    },
    maintenanceClosePromptGridLayout: {
      fontSize: '20px',
      padding: '50px',
      fontWeight: 'bold',
    },
    maintenanceDialogTitle: {
      minWidth: '650px',
      fontSize: '24px',
      textAlign: 'center',
    },
    maintenanceClosePromptLabel: {
      border: '1px solid #ccc',
      textAlign: 'center',
    },
    maintenanceClosePromptValue: {
      border: '1px solid #ccc',
      textAlign: 'center',
      color: 'darkblue',
      fontSize: '20px',
    },
    maintenanceDialogButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: 10,
    },
    maintenanceClosePromptButtonLeft: {
      height: '40px',
      fontSize: '20px',
      width: '150px',
      marginRight: 10,
    },
    maintenanceClosePromptButtonRight: {
      height: '40px',
      fontSize: '20px',
      width: '150px',
      marginLeft: 10,
    },
    columnHeader: {
      whitespace: 'normal',
      height: 'auto',
    },
  })
);

const TimeToErrorCell = (props: GridCellProps) => {
  const dataItem = props.dataItem as PredictiveMaintenanceRecord;
  const timeToError = dataItem?.TimeToErrorDays;
  const confidence = dataItem?.ConfidenceInterval;

  if (timeToError !== undefined && confidence !== undefined) {
    return (
      <td>
        {timeToError} ({confidence})
      </td>
    );
  }
  return <>{timeToError}</>;
};

const useChipStyle = (status: ApiEnums.PredictiveMaintenanceStatus) => {
  switch (status) {
    case ApiEnums.PredictiveMaintenanceStatus.Open:
      return useChipStylesBlue;
    case ApiEnums.PredictiveMaintenanceStatus.TechDispatchRequested:
      return useChipStylesOrange;
    case ApiEnums.PredictiveMaintenanceStatus.TechDispatched:
      return useChipStylesDarkOrange;
    case ApiEnums.PredictiveMaintenanceStatus.DoneByTechEnterprise:
    case ApiEnums.PredictiveMaintenanceStatus.DoneByTechDP:
    case ApiEnums.PredictiveMaintenanceStatus.DoneAutomatically:
      return useChipStylesGreen;
    default:
      return useChipStylesGrey;
  }
};

const maintenanceStatusIconMap = (
  status: ApiEnums.PredictiveMaintenanceStatus
) => {
  switch (status) {
    case ApiEnums.PredictiveMaintenanceStatus.Open:
      return wrenchIcon;
    case ApiEnums.PredictiveMaintenanceStatus.TechDispatchRequested:
      return calendarIcon;
    case ApiEnums.PredictiveMaintenanceStatus.TechDispatched:
      return clockArrowRotateIcon;
    case ApiEnums.PredictiveMaintenanceStatus.DoneByTechEnterprise:
    case ApiEnums.PredictiveMaintenanceStatus.DoneByTechDP:
    case ApiEnums.PredictiveMaintenanceStatus.DoneAutomatically:
      return checkCircleIcon;
    default:
      return questionCircleIcon;
  }
};

const PredictiveMaintenanceGrid: React.FC = ({}): React.ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0]
  );
  const [includeClosed, setIncludeClosed] = React.useState(false);

  const DMM_CONFIRM_TITLE = GetString('DMM_CONFIRM_TITLE');
  const CONFIRM_DISPATCH_TECH = GetString('CONFIRM_DISPATCH_TECH');
  const DMM_CONFIRM_PROMPT = GetString('DMM_CONFIRM_PROMPT');
  const DONE = GetString('DONE');
  const YES = GetString('YES');
  const NO = GetString('NO');
  const DIVISION = GetString('COLUMN_TITLE_DIVISION');
  const STORE = GetString('STORE_TITLE');
  const LANE = GetString('LANE_TITLE');
  const CATEGORY = GetString('COLUMN_TITLE_LANE_CATEGORY');
  const COLUMN_TITLE_PART_NAME = GetString('COLUMN_TITLE_PART_NAME');
  const COLUMN_TITLE_PART_NUMBER = GetString('COLUMN_TITLE_PART_NUMBER');
  const ACTION_CATEGORY = GetString('ACTION_CATEGORY');
  const PRIORITY = GetString('COLUMN_TITLE_PRIORITY');
  const [error, displayError] = React.useState(false);
  const status = GetString('STATUS');

  const [verticalPanes, setVerticalPanes] = React.useState<Array<any>>([
    {},
    {},
  ]);

  const onVerticalChange = (event: SplitterOnChangeEvent) => {
    setVerticalPanes(event.newState);
  };

  const dataState: State = useSelector(
    (state: ApplicationState) =>
      state.userSettingsReducer.predMaintenanceGridDataState
  );

  const [csvData, setCSVData] = React.useState<
    PredictiveMaintenanceRecordCSV[]
  >([]);

  const csvLinkRef = React.useRef<
    CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }
  >(null);

  const records: PredictiveMaintenanceRecord[] = useSelector(
    (state: ApplicationState) => state.maintenanceReducer.predMaintenanceRecords
  );

  const [uniqueKeyOnRefresh, setUniqueKeyOnRefresh] = React.useState<Date>(
    new Date()
  );

  const processWithGroups = (data: any, dataState: State): DataResult => {
    const newDataState = process(data, dataState);

    setGroupIds({ data: newDataState.data, group: dataState.group });
    return newDataState;
  };

  const [resultState, setResultState] = React.useState<DataResult>(
    processWithGroups(records, dataState)
  );

  const newData = resultState.data;

  const [detailExpand, setDetailExpand] =
    React.useState<DetailExpandDescriptor>({ [newData[1]]: true });

  useEffect(() => {
    fetchPredMaintenanceRecords(dispatch, includeClosed);
  }, []);

  const [
    showConfirmCloseMaintenanceDialog,
    setShowConfirmCloseMaintenanceDialog,
  ] = React.useState(false);

  const toggleConfirmCloseMaintenanceDialog = () => {
    if (showConfirmCloseMaintenanceDialog) setSelectedMaintenanceRecord(Object);
    setShowConfirmCloseMaintenanceDialog(!showConfirmCloseMaintenanceDialog);
  };

  const handleIncludeClosedRecords = () => {
    setIncludeClosed(prevState => {
      const newState = !prevState;
      fetchPredMaintenanceRecords(dispatch, newState);
      return newState;
    });
  };

  const DateTimeCell = (props: GridCellProps) => {
    const dataItem = props.dataItem as PreventiveMaintenanceRecord;
    return dataItem && dataItem.UpdateDate ? (
      <td>{new Date(dataItem.UpdateDate).toLocaleDateString()}</td>
    ) : (
      <td></td>
    );
  };

  const dateFilterCell = (props: GridCustomFilterCellProps) => {
    return (
      <CustomDateFilterCell
        gridFilterCellProps={props}
        dataState={dataState}
        fieldName="UpdateDate"
      />
    );
  };

  const handleCloseMaintenanceRecordNo = () => {
    toggleConfirmCloseMaintenanceDialog();
  };

  const handleCloseMaintenanceRecordYes = async () => {
    if (selectedMaintenanceRecord) {
      await updatePredMaintenanceRecord(
        dispatch,
        selectedMaintenanceRecord,
        ApiEnums.PredictiveMaintenanceStatus.DoneByTechEnterprise
      );
    }
    toggleConfirmCloseMaintenanceDialog();
  };

  const [selectedMaintenanceRecord, setSelectedMaintenanceRecord] =
    React.useState<PredictiveMaintenanceRecord>();

  useEffect(() => {
    setResultState(processWithGroups(records, dataState));
  }, [records]);

  const [showRequestDispatchTechDialog, setShowRequestDispatchTechDialog] =
    React.useState(false);

  const toggleRequestDispatchTechDialog = () => {
    if (showRequestDispatchTechDialog) setSelectedMaintenanceRecord(Object);
    setShowRequestDispatchTechDialog(!showRequestDispatchTechDialog);
  };

  const handleRequestDispatchTech_No = () => {
    toggleRequestDispatchTechDialog();
  };

  const handleRequestDispatchTech_Yes = () => {
    if (selectedMaintenanceRecord) {
      // let eta = new Date();
      // eta.setDate(eta.getDate() + 1);
      // eta.setHours(12, 0, 0, 0);
      // selectedMaintenanceRecord.ETA = eta;
      updatePredMaintenanceRecord(
        dispatch,
        selectedMaintenanceRecord,
        ApiEnums.PredictiveMaintenanceStatus.TechDispatchRequested
      );
    }

    toggleRequestDispatchTechDialog();
  };

  const onDropDownItemClick = (
    event: DropDownButtonItemClickEvent,
    record: PredictiveMaintenanceRecord
  ) => {
    switch (event.item) {
      case DONE:
        activateConfirmCloseMaintenanceDialog(record);
        break;
      default:
        break;
    }
  };

  const activateConfirmDispatchDialog = (data: PredictiveMaintenanceRecord) => {
    setSelectedMaintenanceRecord(data);
    setShowRequestDispatchTechDialog(true);
  };

  const activateConfirmCloseMaintenanceDialog = (
    data: PredictiveMaintenanceRecord
  ) => {
    setSelectedMaintenanceRecord(data);
    setShowConfirmCloseMaintenanceDialog(true);
  };

  const onRowDoubleClick = (event: GridRowDoubleClickEvent) => {
    const record = event.dataItem as PredictiveMaintenanceRecord;
    if (record.Status === ApiEnums.PredictiveMaintenanceStatus.Open)
      activateConfirmDispatchDialog(record);
  };

  const onFetchPredMaintenanceRecords = () => {
    let newDataState: State = {
      skip: 0,
      take: dataState.take,
      sort: dataState.sort,
      group: dataState.group,
    };
    setUniqueKeyOnRefresh(new Date());
    savePredMaintenanceGridState(dispatch, newDataState);
    fetchPredMaintenanceRecords(dispatch, includeClosed);
  };

  const fetchError: FetchError = useSelector(
    (state: ApplicationState) => state.maintenanceReducer.fetchError
  );

  const clearFetchError = () => {
    displayError(false);
    resetFetchError(dispatch);
  };

  useEffect(() => {
    let timeoutId: any;
    if (fetchError.StatusCode > 0 && fetchError.Message != '') {
      displayError(true);
      timeoutId = setTimeout(() => {
        clearFetchError();
      }, 10000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [fetchError]);

  const MaintenanceStatusCell = (props: GridCellProps) => {
    const dataItem = props.dataItem as PredictiveMaintenanceRecord;

    let status: string = predMaintenanceStatusTextMap(dataItem.Status);
    let chipStyle: any = useChipStyle(dataItem.Status);
    if (status) {
      const items = [];
      if (
        dataItem.Status <
          ApiEnums.PredictiveMaintenanceStatus.DoneByTechEnterprise &&
        dataItem.ShowDoneButton
      )
        items.push(DONE);

      return (
        <td>
          <Chip
            className={clsx(chipStyle().root, classes.chipStyle)}
            svgIcon={maintenanceStatusIconMap(dataItem.Status)}
          >
            <span className={clsx('k-chip-content', classes.chipContent)}>
              {GetString(status)}
              {items.length > 0 ? (
                <DropDownButton
                  items={items}
                  svgIcon={chevronDownIcon}
                  onItemClick={(event: DropDownButtonItemClickEvent) =>
                    onDropDownItemClick(event, dataItem)
                  }
                />
              ) : null}
            </span>
          </Chip>
        </td>
      );
    }
    return <td></td>;
  };

  const MaintenanceRecordDetail = (props: GridDetailRowProps) => {
    const dataItem = props.dataItem;
    return (
      <div>
        <section style={{ width: '700px', float: 'left' }}>
          <p>
            <strong>{COLUMN_TITLE_PART_NUMBER}:</strong> {dataItem?.PartNumber}
          </p>
          <p>
            <strong>{GetString('COLUMN_TITLE_LANE_UPDATED')}:</strong>{' '}
            {dataItem?.LastUpdated
              ? getLocalDateTime(dataItem.LastUpdated)
              : ''}
          </p>
          {dataItem.ETA ? (
            <p>
              <strong>{GetString('COLUMN_TITLE_ETA')}:</strong>{' '}
              {getLocalDateTime(dataItem.ETA)}
            </p>
          ) : null}
          <p>
            <strong>{GetString('COLUMN_TITLE_CREATED_ON')}:</strong>{' '}
            {getLocalDateTime(dataItem.CreatedOn)}
          </p>
        </section>
      </div>
    );
  };

  const dataStateChange = (event: GridDataStateChangeEvent) => {
    const newDataState = processWithGroups(records, event.dataState);
    savePredMaintenanceGridState(dispatch, event.dataState);
    setResultState(newDataState);
  };

  const getCSVFileName = () => {
    return `PredictiveMaintenance_${getCurrentDateYYYYMMDD()}`;
  };

  const processExportCSV = () => {
    let result: PredictiveMaintenanceRecordCSV[] = [];
    if (Array.isArray(records)) {
      records.forEach(record => {
        let data: any = {
          CustomerName: record.CustomerName,
          StoreNumber: record.StoreNumber,
          SystemType: record.SystemType,
          LaneNumber: record.LaneNumber,
          UnitName: record.UnitName,
          InformationType: record.InformationType,
          Module: record.Module,
          Recommendation: record.Recommendation,
          PartName: record.PartName,
          PartNumber: record.PartNumber,
          Priority: record.Priority,
          DegradationInfo: record.DegradationInfo,
          ShowDoneButton: record.ShowDoneButton,
          ...record.MachineSpecific,
          TimeToErrorDays: record.TimeToErrorDays,
          ConfidenceInterval: record.ConfidenceInterval.toString(),
          UpdateDate: record.UpdateDate,
          MissedDays: record.MissedDays,
          Status: ApiEnums.PredictiveMaintenanceStatus[record.Status],
          ETA: record.ETA,
          LastUpdated: record.LastUpdated,
        };
        delete data.ID;
        delete data.expanded;
        delete data.MachineSpecific;
        result.push(data);
      });
    }
    setCSVData(result);
  };

  useEffect(() => {
    exportCSV();
  }, [csvData]);

  const exportCSV = () => {
    if (csvData.length > 0 && csvLinkRef?.current) {
      csvLinkRef.current.link.click();
    }
  };

  const getGridLayout = () => {
    return (
      <GridLayout
        cols={[{ width: 200 }, { width: 350 }]}
        className={classes.maintenanceClosePromptGridLayout}
        align={{ horizontal: 'stretch' }}
      >
        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {DIVISION}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.CustomerName}
        </GridLayoutItem>

        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {STORE}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.StoreNumber}
        </GridLayoutItem>

        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {LANE}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.LaneNumber}
        </GridLayoutItem>

        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {CATEGORY}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.UnitName}
        </GridLayoutItem>

        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {COLUMN_TITLE_PART_NAME}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.PartName}
        </GridLayoutItem>

        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {COLUMN_TITLE_PART_NUMBER}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.PartNumber}
        </GridLayoutItem>
        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {PRIORITY}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.Priority}
        </GridLayoutItem>
        <GridLayoutItem
          col={1}
          colSpan={1}
          className={classes.maintenanceClosePromptLabel}
        >
          {ACTION_CATEGORY}
        </GridLayoutItem>
        <GridLayoutItem
          col={2}
          colSpan={1}
          className={classes.maintenanceClosePromptValue}
        >
          {selectedMaintenanceRecord?.Recommendation}
        </GridLayoutItem>
      </GridLayout>
    );
  };

  const columnProps = (field: string) => {
    return {
      field: field,
      columnMenu: ColumnMenu,
      headerClassName: isColumnActive(field, dataState) ? 'active' : '',
    };
  };

  const isColumnActive = (field: string, dataState: State) => {
    return (
      isColumnMenuFilterActive(field, dataState.filter) ||
      isColumnMenuSortActive(field, dataState.sort)
    );
  };

  return (
    <React.Fragment>
      <LocalizationProvider language={currentLocale.language}>
        <IntlProvider locale={currentLocale.locale}>
          <Splitter
            panes={verticalPanes}
            orientation={'vertical'}
            onChange={onVerticalChange}
          >
            <div>
              <PredMaintenanceFilter />
            </div>
            <div>
              <CSVLink
                data={csvData}
                ref={csvLinkRef}
                filename={getCSVFileName() + '.csv'}
              />
              <Grid
                key={`${uniqueKeyOnRefresh}`}
                style={{ height: '73vh' }}
                resizable={true}
                sortable={true}
                filterable={true}
                pageable={{
                  buttonCount: 4,
                  pageSizes: [50, 100, 500, 1000, 5000],
                }}
                data={resultState}
                {...dataState}
                groupable={true}
                reorderable={true}
                fixedScroll={false}
                onDataStateChange={dataStateChange}
                defaultDetailExpand={detailExpand}
                rowHeight={50}
                detail={MaintenanceRecordDetail}
                dataItemKey="ID"
                onRowDoubleClick={onRowDoubleClick}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: CustomCell,
                }}
              >
                <GridToolbar>
                  <div className={classes.toolbarButtonContainer}>
                    <div className={classes.toolbarButtonGrid}>
                      <Button
                        type="submit"
                        className={classes.toolbarButton}
                        onClick={onFetchPredMaintenanceRecords}
                      >
                        {GetString('RUN_QUERY')}
                      </Button>
                      <Button
                        type="submit"
                        className={classes.toolbarButton}
                        onClick={processExportCSV}
                      >
                        {GetString('EXPORT_TO_CSV')}
                      </Button>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onClick={handleIncludeClosedRecords}
                            name="includeClosed"
                            color="primary"
                            checked={includeClosed}
                          />
                        }
                        label={GetString('INCLUDE_CLOSED_RECORDS')}
                      />
                    </div>
                  </div>
                </GridToolbar>
                <GridColumn
                  {...columnProps('CustomerName')}
                  title={GetString('COLUMN_TITLE_DIVISION')}
                  width="115px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('StoreNumber')}
                  title={GetString('COLUMN_TITLE_STORE')}
                  width="100px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('LaneNumber')}
                  title={GetString('COLUMN_TITLE_LANE')}
                  width="100px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('SystemType')}
                  title={GetString('COLUMN_TITLE_SYSTEM_TYPE')}
                  width="150px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('UnitName')}
                  title={CATEGORY}
                  width="130px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('Module')}
                  title={GetString('MODULE')}
                  width="140px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('TimeToErrorDays')}
                  title={GetString('TIME_TO_ERROR')}
                  width="160px"
                  cells={{
                    data: TimeToErrorCell,
                  }}
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('DegradationInfo')}
                  title={GetString('DEGRADATION_INFO')}
                  width="200px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('PartName')}
                  title={COLUMN_TITLE_PART_NAME}
                  width="140px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('Recommendation')}
                  title={GetString('ACTION_CATEGORY')}
                  width="140px"
                  columnMenu={ColumnMenu}
                  filterable={false}
                />
                <GridColumn
                  {...columnProps('Priority')}
                  title={PRIORITY}
                  width="185px"
                  columnMenu={ColumnMenu}
                  filter="numeric"
                />
                <GridColumn
                  field="Status"
                  title={GetString('COLUMN_TITLE_STATUS')}
                  width="175px"
                  cells={{
                    data: MaintenanceStatusCell,
                    filterCell: PredictiveMaintenanceStatusFilterCell,
                  }}
                  filterable={true}
                />
                <GridColumn
                  field="UpdateDate"
                  title={GetString('COLUMN_TITLE_LANE_UPDATE_DATE')}
                  width="230px"
                  cells={{ data: DateTimeCell, filterCell: dateFilterCell }}
                  filterable={true}
                />
              </Grid>
            </div>
          </Splitter>
          {showConfirmCloseMaintenanceDialog && (
            <Dialog
              title={DMM_CONFIRM_TITLE}
              onClose={toggleConfirmCloseMaintenanceDialog}
            >
              <div className={classes.maintenanceDialog}>
                <div className={classes.maintenanceDialogTitle}>
                  {DMM_CONFIRM_PROMPT}
                </div>
                {getGridLayout()}
                <DialogActionsBar>
                  <div className={classes.maintenanceDialogButtonContainer}>
                    <Button
                      themeColor={'primary'}
                      type="button"
                      onClick={handleCloseMaintenanceRecordYes}
                      className={classes.maintenanceClosePromptButtonLeft}
                    >
                      {YES}
                    </Button>
                    <Button
                      themeColor={'primary'}
                      type="button"
                      onClick={handleCloseMaintenanceRecordNo}
                      className={classes.maintenanceClosePromptButtonRight}
                    >
                      {NO}
                    </Button>
                  </div>
                </DialogActionsBar>
              </div>
            </Dialog>
          )}
          {showRequestDispatchTechDialog && (
            <Dialog
              title={DMM_CONFIRM_TITLE}
              onClose={toggleRequestDispatchTechDialog}
            >
              <div className={classes.maintenanceDialog}>
                <div className={classes.maintenanceDialogTitle}>
                  {CONFIRM_DISPATCH_TECH}
                </div>
                {getGridLayout()}
                <DialogActionsBar>
                  <div className={classes.maintenanceDialogButtonContainer}>
                    <Button
                      themeColor={'primary'}
                      type="button"
                      onClick={handleRequestDispatchTech_Yes}
                      className={classes.maintenanceClosePromptButtonLeft}
                    >
                      {YES}
                    </Button>
                    <Button
                      themeColor={'primary'}
                      type="button"
                      onClick={handleRequestDispatchTech_No}
                      className={classes.maintenanceClosePromptButtonRight}
                    >
                      {NO}
                    </Button>
                  </div>
                </DialogActionsBar>
              </div>
            </Dialog>
          )}
          <Fade>
            <NotificationGroup className={classes.bottomRight}>
              {error && (
                <Notification
                  className={classes.error}
                  type={{
                    style: 'error',
                    icon: true,
                  }}
                  closable={true}
                  onClose={() => clearFetchError()}
                >
                  <StringResourceManager stringKey={fetchError.Message} />
                  {`(${status}: ${fetchError.StatusCode})`}
                </Notification>
              )}
            </NotificationGroup>
          </Fade>
        </IntlProvider>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default PredictiveMaintenanceGrid;
